import React, { useState } from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';
import Recettes from './detailsRecette/Recettes';
import DetailsRecette from './detailsRecette/DetailsRecette';
import EnteteRecettes from './detailsRecette/EnteteRecettes';
import { getRecetteBoutique } from 'data/Finance/caisse';

const ChoixRecette = ({ setSelectedType }) => {
  return (
    <Card style={{ width: '50%', marginTop: '100px' }}>
      <Card.Body className="d-flex flex-column justify-content-center align-items-center">
        <h3>Choix Recette</h3>
        <div className="d-flex justify-content-around w-100 mt-3 gap-5">
          <Button
            onClick={() => setSelectedType('recette')}
            className="px-4"
            style={{ width: '50%' }}
            variant="outline-primary"
          >
            Recettes Boutiques
          </Button>
          <Button
            onClick={() => setSelectedType('depense')}
            className="px-4"
            variant="outline-primary"
            style={{ width: '50%' }}
          >
            Autres
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

const Recette = () => {
  const [selectedType, setSelectedType] = useState(null);
  const [selectedRecettes, setSelectedRecettes] = useState([]);
  const [montants, setMontants] = useState([]);
  const [showDetails, setShowDetails] = useState(true);
  const [loading, setLoading] = useState(false);
  const [factures, setFactures] = useState([]);
  const [currentCondition, setCurrentCondition] = useState({
    date: [
      new Date(Date.now() - 120 * 24 * 60 * 60 * 1000).toISOString(),
      new Date(Date.now()).toISOString(),
    ],
    magasin: 'Tous',
    session: '',
    etat: 'Tous',
  });
  {
    /* {selectedType ? (
        selectedType === 'recette' ? (
          <FormulaireRecetteBoutique />
        ) : (
          <ChoixRecette />
        )
      ) : (
        <ChoixRecette setSelectedType={setSelectedType} />
      )} */
  }

  const fetchRecettes = async () => {
    setLoading(true);
    try {
      const response = await getRecetteBoutique(currentCondition);
      setFactures(response);
      console.log(response);
    } catch (error) {
      console.error('Error fetching recettes:', error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Row style={{ maxHeight: '450px' }}>
        <Col xs={6} md={6} sm={6} style={{ paddingRight: '15px' }}>
          <Recettes
            selectedRecettes={selectedRecettes}
            setSelectedRecettes={setSelectedRecettes}
            setShowDetails={setShowDetails}
            fetchRecettes={fetchRecettes}
            currentCondition={currentCondition}
            setCurrentCondition={setCurrentCondition}
            loading={loading}
            factures={factures}
          />
        </Col>
        <Col xs={6} md={6} sm={6} style={{ paddingLeft: '0px' }}>
          <DetailsRecette
            selectedRecettes={selectedRecettes}
            setSelectedRecettes={setSelectedRecettes}
            fetchRecettes={fetchRecettes}
            montants={montants}
            setMontants={setMontants}
          />
        </Col>
      </Row>
      {selectedRecettes.length > 0 && selectedRecettes[0].etatFinance === 'Enveloppe validé' && (
        <Row>
          <Col>
            <EnteteRecettes
              session={selectedRecettes[0].ID}
              magasin={selectedRecettes[0].magasin}
              showDetails={showDetails}
              montants={montants}
            />
          </Col>
        </Row>
      )}
    </>
  );
};
export default Recette;
